/**
 * Test IDs for QA automation.
 */
export const testIds = {
  cityInputAutocomplete: "city-input-autocomplete",
  cityInputAutocompleteInput: "city-input-autocomplete-input",
  cityInputAutocompleteOption: "city-input-autocomplete-option",
} as const;
